(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sibling-products"] && !Shopify.designMode) return;
  try {
    function syncSiblingProductColor(root = document) {
    root.querySelectorAll('.sibling-product-colors[data-sibling-color]').forEach((siblingPicker) => {
      const expectedColor = siblingPicker.dataset.siblingColor?.trim().toLowerCase();

      if (!expectedColor) return;

      const productInformation = siblingPicker.closest('.product-information') || document;
      const colorRadios = productInformation.querySelectorAll('variant-picker input[type="radio"]');
      const matchingRadio = Array.from(colorRadios).find((input) => {
        const inputName = input.name?.toLowerCase() || '';
        const isColorInput =
          inputName.startsWith('color-') ||
          inputName.startsWith('colour-');

        return isColorInput && input.value.trim().toLowerCase() === expectedColor;
      });

      if (matchingRadio instanceof HTMLInputElement) {
        if (!matchingRadio.checked) matchingRadio.click();
        return;
      }

      const colorSelect = Array.from(productInformation.querySelectorAll('variant-picker select')).find(
        (select) => {
          const selectName = select.name?.toLowerCase() || '';
          return selectName === 'options[color]' || selectName === 'options[colour]';
        }
      );
      const matchingOption = Array.from(colorSelect?.options || []).find(
        (option) => option.value.trim().toLowerCase() === expectedColor
      );

      if (colorSelect && matchingOption && colorSelect.value !== matchingOption.value) {
        colorSelect.value = matchingOption.value;
        colorSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncSiblingProductColor());
  } else {
    syncSiblingProductColor();
  }

  document.addEventListener('shopify:section:load', (event) => {
    syncSiblingProductColor(event.target);
  });
  } catch(e) { console.error(e); }
})();

})();
